export default "__VITE_ASSET__CTwUA5N8__"